//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import directHeading from "~/components/content/direct/directHeading.vue";
import directSection from "~/components/content/direct/directSection.vue";
import directActionsBlock from "~/components/content/direct/directActionsBlock.vue";

export default {
  name: "directSectionCategories",
  components: {
    directHeading,
    directSection,
    directActionsBlock,
  },
  data() {
    return {
      categories: [
        "Amateur",
        "Nederlands",
        "Échte sex",
        "Herkenbaar",
        "Geen poespas",
      ],
    };
  },
};
